<script>
import CircuitList from '@components/circuit/circuit-list.vue';
import {
  adminPanelMethods,
  authComputed,
  circuitComputed,
  circuitMethods,
} from '@state/helpers';

export default {
  components: {
    CircuitList,
  },
  props: {
    content: {
      type: Object,
      required: false,
      default: null,
    },
    hideBaseCardHeader: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...authComputed,
    ...circuitComputed,
  },
  async beforeMount() {
    if (!this.allCircuits || !this.allCircuits.length) {
      try {
        await this.getAllCircuits({
          orgId: this.userOrgId,
          trainerId: this.trainerId ? this.trainerId : '0',
        });
      } catch (e) {
        console.log(e);
      }
    }
  },
  mounted() {},
  methods: {
    ...adminPanelMethods,
    ...circuitMethods,
    toCircuits() {
      this.$router
        .push({ name: 'circuits' })
        .then(() => this.setHideAdminPanel());
    },
    onSelectCircuitItem(circuit) {
      this.$emit('select-circuit-item', circuit);
    },
  },
};
</script>

<template>
  <div>
    <div class="circuit-selection-wrapper">
      <div class="create-new-circuit" v-if="!hideBaseCardHeader">
        <BaseCardHeader title="Create a brand new circuit" />
        <p
          >Start completely from scratch and build your circuit within the
          context of the overall workout you're working on.</p
        >
        <BaseButton
          type="button"
          class="btn-primary btn-round"
          @click="toCircuits"
        >
          <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-stopwatch invert-color'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 0h6v2H6V0zm2 13V7h2v6H8zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A8.962 8.962 0 009 3a9 9 0 00-9 9c0 4.97 4.02 9 9 9a8.994 8.994 0 007.03-14.61zM2 12c0 3.87 3.13 7 7 7s7-3.13 7-7-3.13-7-7-7-7 3.13-7 7z" fill="#000"/></svg>
          Create New Circuit
        </BaseButton>
      </div>
      <div class="select-existing-circuit">
        <BaseCardHeader title="Start from an existing circuit" />
        <p>
          Start with pre-built circuit and modify the exercises and default
          values within the circuit to get the results you want.
        </p>
      </div>
    </div>

    <CircuitList
      :circuits="allCircuits"
      :inPanel="true"
      @select-circuit-item="onSelectCircuitItem"
    />
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.circuit-selection-wrapper {
  padding: 2rem;

  .create-new-circuit {
    background-color: $color-off-white;
    border-radius: $base-border-radius-md;
    margin-bottom: 3rem;
    padding: 2rem 3rem;

    .icon-stopwatch {
      margin-right: 0.5rem;
      width: 1.4rem;
    }
  }

  .select-existing-circuit {
    padding: 0 3rem;
  }
}

.circuit-list {
  border-right: 0;
  width: 100%;

  ::v-deep {
    .circuit-list-header {
      padding-top: 0;
    }

    .subheader-actions-wrapper {
      .search-input-wrapper {
        padding-left: 3rem;
        width: 80%;

        .input {
          background-color: $color-off-white;
          border-radius: $base-border-radius;
        }
      }

      .button {
        display: none;
      }
    }
  }
}
</style>
